import { useState } from 'react'
import Link from 'next/link'
import { ExperienceIcon, type IconName } from '@comp/ui/experience-icon'
import useStoryPlayback from '@comp/ui/use-story-playback'
import AiSecurityScene from './ai-security-scene'
import { aiCapabilities, aiPages, type AiPage, type AiLang } from './ai-security-content'
import { getAiStory } from './ai-story-content'
import styles from './ai-story.module.css'

export function AiCapabilityGallery({ lang }: { lang: AiLang }) {
  const [selected, setSelected] = useState<Exclude<AiPage, 'overview'>>('agents')
  const tr = lang === 'tr'
  const c = aiPages[selected].copy[lang]
  return <div className={styles.gallery}>
    <div className={styles.capabilityTabs} role="group" aria-label={tr ? 'Hedefinize göre bir özellik seçin' : 'Choose a capability for your goal'}>
      {aiCapabilities.map((key, i) => <button type="button" key={key} aria-pressed={selected === key} onClick={() => setSelected(key)}><span>0{i + 1}</span><ExperienceIcon name={aiPages[key].icon} size={21} /><strong>{aiPages[key].copy[lang].label}</strong><span className={styles.tabLine} /></button>)}
    </div>
    <div className={styles.galleryIntro}><div><span>{tr ? 'NE İŞE YARAR?' : 'WHAT DOES IT DO?'}</span><p>{getAiStory(selected, lang).definition}</p></div><Link href={aiPages[selected].path}>{tr ? `${c.label} detayları` : `Explore ${c.label}`}<ExperienceIcon name="arrow" size={16} /></Link></div>
    <AiSecurityScene key={selected} page={selected} lang={lang} compact />
  </div>
}

export function AiWorkflowMap({ page, lang }: { page: AiPage; lang: AiLang }) {
  const tr = lang === 'tr'
  const c = aiPages[page].copy[lang]
  const playback = useStoryPlayback(3, 3200)
  const active = Math.min(playback.step, 2)
  const workflowIcons: Record<AiPage, IconName[]> = {
    overview: ['bot', 'shield', 'code'], agents: ['bot', 'key', 'shield'],
    gateway: ['apps', 'shield', 'code'], approvals: ['bot', 'user', 'check'],
    trust: ['shield', 'database', 'key'], copilot: ['user', 'database', 'apps'],
  }
  const control = playback.step === 3 ? (tr ? 'Akışı yeniden izle' : 'Replay workflow') : playback.playing ? (tr ? 'Duraklat' : 'Pause') : (tr ? 'Devam et' : 'Continue')
  return <div className={styles.workflowMap} ref={playback.ref} data-playing={playback.running} data-stage={playback.step}>
    <div className={styles.mapTop}><span>{tr ? 'BAŞTAN SONA İŞLEYİŞ' : 'THE WORKFLOW, END TO END'}</span><button type="button" onClick={playback.toggle}><ExperienceIcon name={playback.step === 3 ? 'replay' : playback.playing ? 'pause' : 'play'} size={13} />{control}</button></div>
    <div className={styles.mapNodes} role="group" aria-label={tr ? 'İşleyiş adımları' : 'Workflow steps'}>
      {c.steps.map((step, i) => <div key={step.title} className={styles.mapNode} data-active={active === i} data-complete={playback.step > i}>
        <button type="button" aria-pressed={active === i} onClick={() => playback.seek(i)}><span className={styles.nodeIcon}><ExperienceIcon name={workflowIcons[page][i]} size={29} /></span><span>0{i + 1}</span><strong>{step.title}</strong></button>
        <p>{step.body}</p>
        {i < 2 && <div className={styles.mapConnection}><span /><i key={playback.run} /><ExperienceIcon name="arrow" size={16} /></div>}
      </div>)}
    </div>
    <div className={styles.mapOutcome} data-ready={playback.step === 3}><ExperienceIcon name="shield" size={20} /><div><span>{tr ? 'ULAŞMAK İSTEDİĞİNİZ SONUÇ' : 'THE OUTCOME YOU ARE WORKING TOWARD'}</span><p>{getAiStory(page, lang).outcome}</p></div></div>
  </div>
}
